<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive> -->
    <router-view :key="$route.fullPath">
        <!-- 这里是不被缓存的视图组件，好比 page3 -->
    </router-view>
    <loading v-if="this.$store.state.isLoad"></loading>
  </div>
</template>

<script>
  import store from 'vuex'
  import loading from './components/loading.vue'
  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isAlive: true
      }
    },
    methods: {
      reload() {
        this.isAlive = false;
        this.$nextTick(function () {
          this.isAlive = true
        })
      }
    },
    components: {
      loading
    },
  }
</script>



// WEBPACK FOOTER //
// src/App.vue